import React from "react"
import { appConfig } from "../config.js"


/**
 * small muted info hint with an info-circle icon
 *
 * props:
 *   - children     the hint text/content
 *   - iconSize     (optional) icon + text font-size, default "15px"
 *   - centered     (optional) center the hint, default true
 *   - style        (optional) additional styles to merge
 */
export default function Hint(props) {
	const iconSize = props.iconSize || "15px"
	const centered = props.centered !== false

	return (
		<div style={{
			color: appConfig.theme.backgroundColorLighter3,
			fontSize: iconSize,
			display: "flex",
			alignItems: "center",
			justifyContent: centered ? "center" : "flex-start",
			gap: "10px",
			...props.style,
		}}>
			<i style={{ fontSize: iconSize, flexShrink: 0 }} className="fa fa-info-circle" />
			<span>{props.children}</span>
		</div>
	)
}
